"use client";

import React from "react";
import Image from "../../assets/images/Transparenz.jpeg"

export function SecurityMeasures() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28 bg-[#B0D6FC]">
      <div className="container  md:max-w-5xl lg:max-w-7xl mx-auto ">
        <div className="grid grid-cols-1 gap-y-12 md:grid-cols-2 md:items-center md:gap-x-12 lg:gap-x-20">
        <div>
            <img
              src={Image}
              className="w-full h-150 object-cover rounded-xl"
              alt="Relume placeholder image"
            />
          </div>
          <div>
          
            <h1 className="mb-5 text-4xl leading-[1.2] md:mb-6 md:text-[45px] lg:text-[45px] max-w-[500px]">
            Gewährleisten Sie die Wirksamkeit Ihrer Sicherheitsmaßnahmen mit unserer umfassenden Sicherheitsanalyse

            </h1>
            <p className="md:text-md">
            Unsere Sicherheitsanalyse bietet gründliche Audits zur Bewertung Ihrer aktuellen Sicherheitsprotokolle. Wir stellen sicher, dass Ihre Verteidigungsmaßnahmen robust sind und den neuesten Industriestandards entsprechen.
            </p>
          </div>
         
        </div>
      </div>
    </section>
  );
}
